export default __webpack_public_path__ + "static/media/tempMap.f18d1c70.png";